import React from "react";
import { FormattedMessage } from "react-intl";

// mui
import Typography from "@mui/material/Typography";

// image
import uploadingImg from "../../../../../../../../../../images/ocr_image/ocr_file_uploading.svg";

const UploadContent = () => (
  <>
    <img src={uploadingImg} alt="uploadingImg" height={200} width={200} />
    <Typography sx={{ fontWeight: "700", fontSize: "20px" }}>
      <FormattedMessage
        id="sna.sidetool.digitalAITool.ocr.uploading.hint1"
        defaultMessage="Uploading file, please wait..."
      />
    </Typography>
  </>
);

export default UploadContent;
